import React from 'react';
import Input from '../../../../components/forms/Input';
import SelectField from '../../../../components/forms/SelectField';
import TimezoneSelect from '../TimezoneSelect';
import AddressFields from '../AddressFields';
import Checkbox from '../../../forms/Checkbox';

const EventInputs = ({ onInput, data, errors, contextOptions, withContext }) => (
    <div className="ckp-admin-forms-body">
        <div className="ckp-admin-grid-row">
            <div className="ckp-admin-grid-column">
                <SelectField
                    disabled={withContext}
                    items={contextOptions}
                    label="Organization *"
                    onChange={onInput}
                    name="organizationId"
                    value={data.organizationId}
                />
            </div>
            <div className="ckp-admin-grid-column">
                <Input
                    errorMessage={errors.name}
                    label="Event Name *"
                    name="name"
                    onChange={onInput}
                    value={data.name}
                />
            </div>
            <div className="ckp-admin-grid-column">
                <TimezoneSelect label="Event Timezone *" value={data.timeZone} onChange={onInput} />
            </div>
        </div>
        <AddressFields errors={errors} data={data} onInput={onInput} />
        <div className="ckp-admin-grid-row">
            <div className="ckp-admin-grid-column">
                <Checkbox
                    onChange={() => onInput(!data.chatEnabled, 'chatEnabled')}
                    checked={!!data.chatEnabled}
                    name="chatEnabled"
                    label="Enable live chat"
                />
            </div>
        </div>
    </div>
);

export default EventInputs;
